/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

import FormField, { CustomFormFieldProps } from './FormField'
import { ColorInput, ColorInputProps } from '@mantine/core'

export type FormColorFieldProps = CustomFormFieldProps<ColorInputProps>

function FormColorField (props: FormColorFieldProps) {
  const { name, ...others } = props
  return (
    <FormField
      {...others}
      name={name}
      render={ColorInput}
    />
  )
}

export default FormColorField
